import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { QUERY_PARAMS } from '../../../core/configurations/router';

export const enum EErrorId {
  notFound,
  missedTranscription,
  missedTranscriptionId,
  accessDenied,
  serverIssue,
  accessDeniedTranscription,
}

interface IErrorConfig {
  icon: string;
  message: string;
}

export const ERROR_CONFIG: Readonly<Record<EErrorId, IErrorConfig>> = {
  [EErrorId.notFound]: {
    icon: 'assets/icons/404.svg',
    message: 'Sorry, the page your are looking for does not exist.',
  },
  [EErrorId.serverIssue]: {
    icon: 'assets/icons/error.svg',
    message: 'Sorry, the service is unavailable please try again later or contact support.',
  },
  [EErrorId.missedTranscription]: {
    icon: 'assets/icons/missing-transcript.svg',
    message: 'Sorry, there is no information found by provided id.',
  },
  [EErrorId.missedTranscriptionId]: {
    icon: 'assets/icons/missing-id.svg',
    message: 'Id parameter is missing. Provide an id to see a transcription.',
  },
  [EErrorId.accessDenied]: {
    icon: 'assets/icons/access-denied.svg',
    message: 'Sorry, you can not see this page.',
  },
  [EErrorId.accessDeniedTranscription]: {
    icon: 'assets/icons/access-denied.svg',
    message: 'You do not have access to this communication.',
  },
};

@Component({
  selector: 'cv-not-found',
  standalone: true,
  imports: [NgOptimizedImage],
  template: `
    <div class="not-found">
      <article class="not-found__card">
        <img [ngSrc]="errorConfig.icon" priority alt="error icon" height="150" width="150" />

        <h2 class="not-found__message">{{ errorConfig.message }}</h2>
        <span class="not-found__support">
          Please contact
          <a href="mailto:support@leasehawk.com">support&#64;leasehawk.com</a> for any questions.</span
        >
      </article>
    </div>
  `,
  styleUrl: './not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent implements OnInit {
  @Input() errorConfig: IErrorConfig = ERROR_CONFIG[EErrorId.notFound];

  constructor(private readonly activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    const { [QUERY_PARAMS.errorId]: code } = this.activatedRoute.snapshot.queryParams as Record<string, string>;
    this.errorConfig = ERROR_CONFIG[Number(code) as EErrorId] ?? this.errorConfig;
  }
}
